<template>
  <div class="join">
    <div class="banner">
      <img src="../../assets/images/join/banner.png" alt />
    </div>
    <!-- 切换选项 -->
    <div class="optionList">
      <ul class="option">
        <li
          v-for="(item, i) in optionData"
          :class="{ active : joinActive === i }"
          :key="i"
          @click="joinActive = i, $router.push({ path: item.path }), saveNavState(i)"
        >{{item.name}}</li>
      </ul>
    </div>
    <!-- 板块 -->
    <div class="contentList">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  props: ['inputValue'],
  data() {
    return {
      joinActive: 0,
      optionData: [
        { name: '人才招聘', path: 'Recruits' },
        { name: '公司福利', path: 'Welfare' },
        { name: '办公环境', path: 'Environment' }
      ]
    }
  },
  created() {},
  mounted() {
    if (window.sessionStorage.getItem('joinActive') === null) {
      window.sessionStorage.setItem('joinActive', 0)
    }
    this.joinActive = parseInt(window.sessionStorage.getItem('joinActive'))
    if (this.inputValue !== 0) {
      this.joinActive = this.inputValue
    }
  },
  methods: {
    // 保存链接的激活状态
    saveNavState(active) {
      window.sessionStorage.setItem('joinActive', active)
      this.joinActive = active
    }
  }
}
</script>

<style scoped>
.join {
  width: 100%;
}
.join .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.join .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
.join .optionList {
  width: 100%;
  background-color: #fff;
  height: 60px;
  border-bottom: 1px solid #dcdcdc;
}
.join .optionList .option {
  max-width: 1100px;
  margin: 0 auto;
  line-height: 60px;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  justify-content: center;
}
.join .optionList .option li {
  width: 150px;
  height: 60px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.join .optionList .option li.active {
  border-bottom: 3px solid #000;
}
.join .contentList {
  width: 100%;
}
</style>
